import { cachedFetch } from './cachedFetch';
import { customHttpAgentForDev } from './customHttpAgent';
import { validateUrl } from '../../urlManipulations/validateUrl';
import { isDebugMode } from '@/constants';
// import { log } from '@/utils/logger';
const isEmpty = obj => {
  if (!obj) return true;
  if (Array.isArray(obj)) return obj.length === 0;
  return Object.keys(obj).length === 0;
};

/**
 * Fetches data from a REST API endpoint with validation, caching, and metrics
 *
 * @param url - The endpoint URL to fetch from
 * @param options - Request options including headers, method, etc.
 * @returns Promise that resolves to the Response object
 *
 * @throws {Error} When the request fails or returns an error status
 */
export const fetchRestApiEndpoint = async (url, options) => {
  const validatedUrl = validateUrl(url);
  // const method = options?.method || 'GET';
  // const metrics = new RequestMetrics(validatedUrl, method);

  const defaultHeaders = {};

  const headers = {
    ...defaultHeaders,
    ...(isEmpty(options.headers) ? {} : options.headers || {}),
  };

  const requestOptions = {
    ...customHttpAgentForDev(),
    ...options,
    headers,
  };

  // metrics.logStart(requestOptions);

  const request = new Request(validatedUrl, requestOptions);

  try {
    const response: Response = await cachedFetch(request);

    // Handle 4xx errors with JSON content
    if (
      response.status.toString().startsWith('4') &&
      response.headers.get('Content-Type')?.includes('application/json')
    ) {
      const json = await response.json();
      if (process.env.NODE_ENV === 'development') {
        const error = new Error(json.message);
        // metrics.logEnd(response, json, error);
        throw error;
      }
    }

    if (response.ok) {
      // Only log cache misses to avoid spam from cached responses
      if (!response.headers.get('x-nextjs-cache')) {
        // metrics.logEnd(response);
      }
      return response;
    } else {
      const error = new Error(`Response not ok: ${response.status} ${response.statusText}`);
      // metrics.logEnd(response, undefined, error);
      throw error;
    }
  } catch (error) {
    const errorObj = error instanceof Error ? error : new Error(String(error));

    console.error(errorObj);

    // Only log if not already logged by metrics above
    // if (!errorObj.message.includes('Response not ok')) {
    //   // metrics.logEnd(undefined, undefined, errorObj);
    // }

    if (isDebugMode) {
      throw errorObj;
    }

    throw errorObj;
  }
};
